/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './LocalArea.scss'
import React from 'react'

function LocalArea(props) {
  return <div className="LocalArea">{props.children}</div>
}

export default LocalArea
